// Константы в данном файле это хардкод для консультанта по недвидимости
// При раскатке функционала в регионах данные возможно нужно будет брать из api
export const AGENT_PHONE = '+74951376592';
export const CALL_FROM = '10:00';
export const CALL_TO = '19:00';
export const MOSCOW_TIMEZONE = 3;
